// styles/lib/icons.scss
export type Icon =
  'alert' |
  'at' |
  'bell-2-solid' |
  'bell-2' |
  'bold' |
  'bookmark-empty' |
  'bookmark' |
  'cancel-5' |
  'close' |
  'cog' |
  'communities-solid' |
  'communities' |
  'cross-2' |
  'down-open' |
  'facebook' |
  'hash' |
  'help' |
  'home-clear' |
  'home-filled' |
  'in-reply' |
  'information' |
  'instagram' |
  'italic' |
  'left-open' |
  'like-filled' |
  'like-outline' |
  'link-ext' |
  'link' |
  'location' |
  'lock-open' |
  'lock' |
  'logout' |
  'mail-1' |
  'mail' |
  'messages-solid' |
  'messages' |
  'newsfeed' |
  'ok' |
  'paper-plane' |
  'pencil-1' |
  'pencil' |
  'people' |
  'picture' |
  'plus-2' |
  'plus' |
  'profile-1' |
  'right-open' |
  'search-1' |
  'search' |
  'settings' |
  'smile' |
  'tag-2' |
  'thumbs-up-filled' |
  'thumbs-up' |
  'tick-2' |
  'twitter' |
  'underline' |
  'up-open' |
  'youtube' |
  'zoom-in';

export default function Icon({ icon, className = '' }: {icon: Icon, className?: string}): JSX.Element {
  return (
    <span className={`icon icon-${icon} ${className}`} />
  );
}
